/**
 * Sign-in redirect page.
 *
 * The panel has no in-app credential form: reaching the login route means the
 * user has no active session, so hand off to the identity provider / access
 * portal immediately and show a brief redirecting state.
 */

import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import BrandLockup from '../common/BrandLockup';
import { signIn } from '@/auth/sso';

const LoginContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
  background: (theme as any).custom?.login?.containerGradient?.(theme.palette) ||
    `linear-gradient(135deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[200]} 100%)`,
  padding: theme.spacing(3),
}));

const CustomLoginPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    signIn();
  }, []);

  return (
    <LoginContainer>
      <BrandLockup orientation="stacked" size={isMobile ? 52 : 60} />
      <CircularProgress size={28} />
      <Typography variant="body2" color="text.secondary">
        Redirigiendo al inicio de sesión…
      </Typography>
    </LoginContainer>
  );
};

export default CustomLoginPage;
